import { Navigate, Route, Routes } from "react-router-dom";

import Home from "../views/Home";
import About from "../views/About/About";
import DisclaimerAndGuide from "../views/DisclaimerAndGuide";
import Dashboard from "../views/Dashboard";
import GetStarted from "../views/Dashboard/partials/GetStarted/GetStarted";
import DroughtRisk from "../views/Dashboard/partials/DroughtRisk/DroughtRisk";
import DroughtIndices from "../views/Dashboard/partials/DroughtIndices/DroughtIndices";
import FinancialIndices from "../views/Dashboard/partials/FinancialIndices/FinancialIndices";
import Layout from "./Layout";
import SelectCountriesTab from "../views/Dashboard/partials/GetStarted/partials/SelectCountriesTab/SelectCountriesTab";
import UploadShapeFile from "../views/Dashboard/partials/GetStarted/partials/UploadShapeFile/UploadShapeFile";
import Docs from "../views/Docs/Docs";

export function App() {
  return (
    <Routes>
      <Route path="/api/docs" element={<Docs />} />
      <Route element={<Layout />}>
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/home" element={<Home />} />
        <Route path="/verification" element={<Home />} />
        <Route path="/reset-password" element={<Home />} />
        <Route path="/disclaimer" element={<DisclaimerAndGuide />} />
        <Route path="/about" element={<About />} />
        <Route path="/introduction" element={<About />} />
        <Route path="/dashboard" element={<Dashboard />}>
          <Route path="get-started" element={<GetStarted />}>
            <Route index element={<SelectCountriesTab />} />
            <Route path="country" element={<SelectCountriesTab />} />
            <Route path="upload" element={<UploadShapeFile />} />
          </Route>
          <Route path="drought-risk" element={<DroughtRisk />} />
          <Route path="drought-indices" element={<DroughtIndices />} />
          <Route path="financial-indices" element={<FinancialIndices />} />
        </Route>
        <Route path="*" element={<About />} /> {/* 404 fallback */}
      </Route>
    </Routes>
  );
}

export default App;
